import { InjectionToken } from "@angular/core";
import { IReceiverRestClient } from "./i-receiver-rest.client";

export const receiverRestClientInjectionToken: InjectionToken<IReceiverRestClient> = new InjectionToken<IReceiverRestClient>("digital-signage.user-dashboard.dashboard-web.ReceiverRestClient");
